import { render, staticRenderFns } from "./SensorEdit.vue?vue&type=template&id=197c6995&scoped=true&"
import script from "./SensorEdit.vue?vue&type=script&lang=js&"
export * from "./SensorEdit.vue?vue&type=script&lang=js&"
import style0 from "./SensorEdit.vue?vue&type=style&index=0&id=197c6995&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c6995",
  null
  
)

export default component.exports